export default {
  setEngagementModerationReasons(state, payload) {
    state.engagementModerationReasons = payload;
  },
};
